import React, { useContext, useEffect } from 'react';
import { CategoryUsageView } from './CategoryUsage.view';
import { GetCategoriesUsageLazyQueryHookResult } from '../../../../models/graphql';
import { AnalyticsContext } from '../../AnalyticsProvider';
import { format } from 'date-fns';
import { AppContext } from '../../../../providers/AppProvider';

type CategoryUsageControllerProps = {
  getData: GetCategoriesUsageLazyQueryHookResult[0];
  loading: boolean;
  data: GetCategoriesUsageLazyQueryHookResult[1]['data'];
};
export const CategoryUsageController = ({ getData, loading, data }: CategoryUsageControllerProps) => {
  const { selectedWorkspaceId } = useContext(AppContext);
  const { startDate, endDate, selectedProfilesIds } = useContext(AnalyticsContext);
  const formattedStartDate = format(startDate, 'yyyy-MM-dd');
  const formattedEndDate = format(endDate, 'yyyy-MM-dd');

  useEffect(() => {
    const executeQuery = async () => {
      await getData({
        variables: {
          workspaceId: selectedWorkspaceId ?? '',
          startDate: formattedStartDate,
          endDate: formattedEndDate,
          selectedProfilesIds
        },
        fetchPolicy: 'no-cache'
      });
    };
    if (selectedProfilesIds && selectedProfilesIds.length > 0) {
      executeQuery();
    }
  }, [getData, formattedStartDate, selectedProfilesIds, formattedEndDate, selectedWorkspaceId]);

  return <CategoryUsageView loading={loading} data={data} />;
};
